import { render, staticRenderFns } from "./UiDropdownItem.vue?vue&type=template&id=511213fc&"
import script from "./UiDropdownItem.vue?vue&type=script&lang=js&"
export * from "./UiDropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports